<template>
  <div>
    <form-field-select
      label="Good reason for selling"
      v-model="form.deal_probability_has_good_reason_for_selling"
      :validation-errors="validationErrors.deal_probability_has_good_reason_for_selling"
    >
      <option :value="null">Unknown</option>
      <option :value="true">Yes</option>
      <option :value="false">No</option>
    </form-field-select>

    <form-field-select
      label="House is vacant"
      v-model="form.deal_probability_house_vacant"
      :validation-errors="validationErrors.deal_probability_house_vacant"
    >
      <option :value="null">Unknown</option>
      <option :value="true">Yes</option>
      <option :value="false">No</option>
    </form-field-select>

    <form-field-select
      label="Repairs are needed"
      v-model="form.deal_probability_needs_repairs"
      :validation-errors="validationErrors.deal_probability_needs_repairs"
    >
      <option :value="null">Unknown</option>
      <option :value="true">Yes</option>
      <option :value="false">No</option>
    </form-field-select>

    <form-field-select
      label="Urgency to close"
      v-model="form.deal_probability_has_urgency"
      :validation-errors="validationErrors.deal_probability_has_urgency"
    >
      <option :value="null">Unknown</option>
      <option :value="true">Yes</option>
      <option :value="false">No</option>
    </form-field-select>

    <form-field-select
      label="Asking price less than Zestimate"
      v-model="form.deal_probability_less_then_zestimate"
      :validation-errors="validationErrors.deal_probability_less_then_zestimate"
    >
      <option :value="null">Unknown</option>
      <option :value="true">Yes</option>
      <option :value="false">No</option>
    </form-field-select>

    <form-field-select
      label="Doesn't want to list with agent"
      v-model="form.deal_probability_not_list_with_agent"
      :validation-errors="validationErrors.deal_probability_not_list_with_agent"
    >
      <option :value="null">Unknown</option>
      <option :value="true">Yes</option>
      <option :value="false">No</option>
    </form-field-select>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "LeadDealProbabilityForm",
  props: ["formData"],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        deal_probability_has_good_reason_for_selling: false,
        deal_probability_house_vacant: false,
        deal_probability_needs_repairs: false,
        deal_probability_has_urgency: false,
        deal_probability_less_then_zestimate: false,
        deal_probability_not_list_with_agent: false,
      },
    };
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
    this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  methods: {
    update() {
      const dealProbabilityData = {
        "deal_probability_has_good_reason_for_selling": this.form.deal_probability_has_good_reason_for_selling,
        "deal_probability_house_vacant": this.form.deal_probability_house_vacant,
        "deal_probability_needs_repairs": this.form.deal_probability_needs_repairs,
        "deal_probability_has_urgency": this.form.deal_probability_has_urgency,
        "deal_probability_less_then_zestimate": this.form.deal_probability_less_then_zestimate,
        "deal_probability_not_list_with_agent": this.form.deal_probability_not_list_with_agent,
      };

      return this.$api.records.updateDealProbability(this.form.id, dealProbabilityData)
        .then(res => {
          this.$buefy.toast.open({
            message: "Lead deal probability was updated",
            type: "is-success"
          });

          return res;
        });
    },
  },
};
</script>

<style scoped>

</style>
